import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import PSInputText from "components/globals/ui/input/PSInputText";
import { PSSubmit } from "components/globals/ui/input/PSInputs";
import { StandardErrorMessage } from "components/globals/messages/StandardMessages";
import { useSelector } from "react-redux";


export default function Search({ onClose }) {
	const { loading, error } = useSelector((state) => state.auth);
  const form = useForm();
  const { handleSubmit } = form;
  const navigate = useNavigate();

	const submitForm = (data) => {
		if(onClose) { onClose(); }
		navigate(`/search/${data.query}`);
	};

	return (
		<>
			<form onSubmit={handleSubmit(submitForm)}>

				<PSInputText
					register={form.register}
					name="query"
					label=""
					type="text"
				/>

				<PSSubmit label="Search" loading={loading} />
				{error && <StandardErrorMessage msg={error} />}

			</form>
		</>
	);
}
